/*
 * Copyright (c) 2023, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */

import React from 'react'
import PropTypes from 'prop-types'

import {Box, Text, useTheme} from '@salesforce/retail-react-app/app/components/shared/ui'

const MobileListMenuTrigger = ({name, isOpen, onOpen, onClose}) => {
    const theme = useTheme()
    const {baseStyle} = theme.components.ListMenu

    const keyMap = {
        Escape: () => onClose(),
        Enter: () => onOpen()
    }

    return (
        <Box {...baseStyle.listMenuTriggerContainer}>
            <Text
                {...baseStyle.listMenuTriggerLink}
                {...{name: name + ' __'}}
                {...(isOpen ? baseStyle.listMenuTriggerLinkActive : {})}
                className={`level-1-link ${name === 'Sale' ? 'saleColor' : ''}`}
                onKeyDown={(e) => {
                    keyMap[e.key]?.(e)
                }}
                tabIndex={'0'}
                padding={0}
                margin={0}
            >
                {name}
            </Text>
        </Box>
    )
}

MobileListMenuTrigger.propTypes = {
    item: PropTypes.object,
    name: PropTypes.string,
    isOpen: PropTypes.bool,
    onOpen: PropTypes.func,
    onClose: PropTypes.func
}

export {MobileListMenuTrigger}
